import { ACTION_SET_UI, ACTION_IS_LOADING, ACTION_SET_ROUTES } from "../action";

const reduceUi = (state = {
	numberOfLivePosts: 5,
}, action)=>{
	switch (action.type) {
		case ACTION_SET_UI:
			return {
				...state,
				[action.payload.key]: action.payload.value,
			}
		case ACTION_IS_LOADING:
			return {
				...state,
				[`${action.payload.part}IsLoading`]: action.payload.isLoading,
			}
	}
	return state;
};

export default reduceUi;